import React, { Component } from 'react';
import axios from 'axios';
import './styles/blog.css';
import { Helmet } from 'react-helmet'

import Disqus from 'disqus-react';

class BlogPost extends Component {
  constructor() {
    super();
    this.state = { 
      blog_post: {}
    }
  }

  handleNewComment(comment) {
  }

  componentDidMount() {
    axios.all([
      axios.get(process.env.REACT_APP_API + '/api/blog/' + this.props.match.params.slug + "/")
    ])
    .then(axios.spread((response) => {
      this.setState({blog_post: response.data});
      console.log(this.state.blog_post.slug);
    }));
  }

  render() {
    const disqus_config = {
      url: "https://modelzoo.co/blog/" + this.state.blog_post.slug,
      identifier: this.state.blog_post.slug,
      title: this.state.blog_post.title,
    }

    const blog_post = this.state.blog_post;
    return blog_post ? 
    (
    <div>

    <Helmet>
      <title>{blog_post.title + " - Model Zoo"}</title>
      <meta name="description" content={blog_post.description} />
    </Helmet>

    <div className="blog-post-div">
    <div className="header"><img src={ process.env.PUBLIC_URL + "/media/" + blog_post.header }/></div>
    <h1 className="title">{ blog_post.title }</h1>
    <p className="date">{ blog_post.created_at }</p>
    <hr />
    <p className="content" dangerouslySetInnerHTML={{__html: blog_post.content}}></p>
    <br/>

    <Disqus.DiscussionEmbed shortname="modelzoo" config={disqus_config} />
    </div>
    <br/>
    <br/>
    </div>
    )
    : "";
  }
}

export default BlogPost



// WEBPACK FOOTER //
// ./src/BlogPost.jsx